import Box from '@mui/material/Box'

const VideoEmbed = ({ videoId }) => {

  if (!videoId) return null

  return (
    <Box 
      sx={{
        position: 'relative',
        paddingBottom: '56.25%', // 16:9 aspect ratio
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        title="Vimeo Video"
        src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0`}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </Box>
  )
}

export default VideoEmbed
